// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1UktU","alert":"SettungsInbox_alert__wauCj"};